// source: jkf-board/board-client/job.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var jkf$board_board$atom_atom_pb = require('../../jkf-board/board-atom/atom_pb.js');
goog.object.extend(proto, jkf$board_board$atom_atom_pb);
goog.exportSymbol('proto.job.AllJobListReq', null, global);
goog.exportSymbol('proto.job.AllJobListRes', null, global);
goog.exportSymbol('proto.job.JobDetailReq', null, global);
goog.exportSymbol('proto.job.JobDetailRes', null, global);
goog.exportSymbol('proto.job.LadyJobInfo', null, global);
goog.exportSymbol('proto.job.PersonalJobDetailReq', null, global);
goog.exportSymbol('proto.job.PersonalJobDetailRes', null, global);
goog.exportSymbol('proto.job.PersonalJobListReq', null, global);
goog.exportSymbol('proto.job.PersonalJobListRes', null, global);
goog.exportSymbol('proto.job.PersonalJobRewardReq', null, global);
goog.exportSymbol('proto.job.PersonalJobRewardRes', null, global);
goog.exportSymbol('proto.job.RegisterJobReq', null, global);
goog.exportSymbol('proto.job.RegisterJobRes', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.job.RegisterJobReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.job.RegisterJobReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.job.RegisterJobReq.displayName = 'proto.job.RegisterJobReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.job.RegisterJobRes = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.job.RegisterJobRes, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.job.RegisterJobRes.displayName = 'proto.job.RegisterJobRes';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.job.LadyJobInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.job.LadyJobInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.job.LadyJobInfo.displayName = 'proto.job.LadyJobInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.job.AllJobListReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.job.AllJobListReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.job.AllJobListReq.displayName = 'proto.job.AllJobListReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.job.AllJobListRes = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.job.AllJobListRes.repeatedFields_, null);
};
goog.inherits(proto.job.AllJobListRes, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.job.AllJobListRes.displayName = 'proto.job.AllJobListRes';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.job.JobDetailReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.job.JobDetailReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.job.JobDetailReq.displayName = 'proto.job.JobDetailReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.job.JobDetailRes = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.job.JobDetailRes.repeatedFields_, null);
};
goog.inherits(proto.job.JobDetailRes, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.job.JobDetailRes.displayName = 'proto.job.JobDetailRes';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.job.PersonalJobListReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.job.PersonalJobListReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.job.PersonalJobListReq.displayName = 'proto.job.PersonalJobListReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.job.PersonalJobListRes = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.job.PersonalJobListRes.repeatedFields_, null);
};
goog.inherits(proto.job.PersonalJobListRes, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.job.PersonalJobListRes.displayName = 'proto.job.PersonalJobListRes';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.job.PersonalJobDetailReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.job.PersonalJobDetailReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.job.PersonalJobDetailReq.displayName = 'proto.job.PersonalJobDetailReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.job.PersonalJobDetailRes = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.job.PersonalJobDetailRes.repeatedFields_, null);
};
goog.inherits(proto.job.PersonalJobDetailRes, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.job.PersonalJobDetailRes.displayName = 'proto.job.PersonalJobDetailRes';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.job.PersonalJobRewardReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.job.PersonalJobRewardReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.job.PersonalJobRewardReq.displayName = 'proto.job.PersonalJobRewardReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.job.PersonalJobRewardRes = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.job.PersonalJobRewardRes, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.job.PersonalJobRewardRes.displayName = 'proto.job.PersonalJobRewardRes';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.job.RegisterJobReq.prototype.toObject = function(opt_includeInstance) {
  return proto.job.RegisterJobReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.job.RegisterJobReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.job.RegisterJobReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    accessToken: jspb.Message.getFieldWithDefault(msg, 1, ""),
    trackingNum: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.job.RegisterJobReq}
 */
proto.job.RegisterJobReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.job.RegisterJobReq;
  return proto.job.RegisterJobReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.job.RegisterJobReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.job.RegisterJobReq}
 */
proto.job.RegisterJobReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccessToken(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTrackingNum(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.job.RegisterJobReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.job.RegisterJobReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.job.RegisterJobReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.job.RegisterJobReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccessToken();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTrackingNum();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string access_token = 1;
 * @return {string}
 */
proto.job.RegisterJobReq.prototype.getAccessToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.job.RegisterJobReq} returns this
 */
proto.job.RegisterJobReq.prototype.setAccessToken = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string tracking_num = 2;
 * @return {string}
 */
proto.job.RegisterJobReq.prototype.getTrackingNum = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.job.RegisterJobReq} returns this
 */
proto.job.RegisterJobReq.prototype.setTrackingNum = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.job.RegisterJobRes.prototype.toObject = function(opt_includeInstance) {
  return proto.job.RegisterJobRes.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.job.RegisterJobRes} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.job.RegisterJobRes.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.job.RegisterJobRes}
 */
proto.job.RegisterJobRes.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.job.RegisterJobRes;
  return proto.job.RegisterJobRes.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.job.RegisterJobRes} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.job.RegisterJobRes}
 */
proto.job.RegisterJobRes.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.job.RegisterJobRes.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.job.RegisterJobRes.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.job.RegisterJobRes} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.job.RegisterJobRes.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.job.LadyJobInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.job.LadyJobInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.job.LadyJobInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.job.LadyJobInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    jobId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    trackingNum: jspb.Message.getFieldWithDefault(msg, 3, ""),
    jobType: jspb.Message.getFieldWithDefault(msg, 4, 0),
    priceType: jspb.Message.getFieldWithDefault(msg, 5, 0),
    singlePrice: jspb.Message.getFieldWithDefault(msg, 6, 0),
    needPerson: jspb.Message.getFieldWithDefault(msg, 7, 0),
    deadline: (f = msg.getDeadline()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    conditionType: jspb.Message.getFieldWithDefault(msg, 9, 0),
    isRegister: jspb.Message.getBooleanFieldWithDefault(msg, 10, false),
    entityInfo: (f = msg.getEntityInfo()) && jkf$board_board$atom_atom_pb.EntityInfo.toObject(includeInstance, f),
    adsInfo: (f = msg.getAdsInfo()) && jkf$board_board$atom_atom_pb.AdsInfo.toObject(includeInstance, f),
    totalPrice: jspb.Message.getFieldWithDefault(msg, 13, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.job.LadyJobInfo}
 */
proto.job.LadyJobInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.job.LadyJobInfo;
  return proto.job.LadyJobInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.job.LadyJobInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.job.LadyJobInfo}
 */
proto.job.LadyJobInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setJobId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTrackingNum(value);
      break;
    case 4:
      var value = /** @type {!proto.atom.JobType} */ (reader.readEnum());
      msg.setJobType(value);
      break;
    case 5:
      var value = /** @type {!proto.atom.PriceType} */ (reader.readEnum());
      msg.setPriceType(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSinglePrice(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setNeedPerson(value);
      break;
    case 8:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDeadline(value);
      break;
    case 9:
      var value = /** @type {!proto.atom.ConditionsType} */ (reader.readEnum());
      msg.setConditionType(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsRegister(value);
      break;
    case 11:
      var value = new jkf$board_board$atom_atom_pb.EntityInfo;
      reader.readMessage(value,jkf$board_board$atom_atom_pb.EntityInfo.deserializeBinaryFromReader);
      msg.setEntityInfo(value);
      break;
    case 12:
      var value = new jkf$board_board$atom_atom_pb.AdsInfo;
      reader.readMessage(value,jkf$board_board$atom_atom_pb.AdsInfo.deserializeBinaryFromReader);
      msg.setAdsInfo(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotalPrice(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.job.LadyJobInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.job.LadyJobInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.job.LadyJobInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.job.LadyJobInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getJobId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTrackingNum();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getJobType();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getPriceType();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getSinglePrice();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getNeedPerson();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getDeadline();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getConditionType();
  if (f !== 0.0) {
    writer.writeEnum(
      9,
      f
    );
  }
  f = message.getIsRegister();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
  f = message.getEntityInfo();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      jkf$board_board$atom_atom_pb.EntityInfo.serializeBinaryToWriter
    );
  }
  f = message.getAdsInfo();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      jkf$board_board$atom_atom_pb.AdsInfo.serializeBinaryToWriter
    );
  }
  f = message.getTotalPrice();
  if (f !== 0) {
    writer.writeInt64(
      13,
      f
    );
  }
};


/**
 * optional int64 job_id = 1;
 * @return {number}
 */
proto.job.LadyJobInfo.prototype.getJobId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.job.LadyJobInfo} returns this
 */
proto.job.LadyJobInfo.prototype.setJobId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.job.LadyJobInfo.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.job.LadyJobInfo} returns this
 */
proto.job.LadyJobInfo.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string tracking_num = 3;
 * @return {string}
 */
proto.job.LadyJobInfo.prototype.getTrackingNum = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.job.LadyJobInfo} returns this
 */
proto.job.LadyJobInfo.prototype.setTrackingNum = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional atom.JobType job_type = 4;
 * @return {!proto.atom.JobType}
 */
proto.job.LadyJobInfo.prototype.getJobType = function() {
  return /** @type {!proto.atom.JobType} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.atom.JobType} value
 * @return {!proto.job.LadyJobInfo} returns this
 */
proto.job.LadyJobInfo.prototype.setJobType = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional atom.PriceType price_type = 5;
 * @return {!proto.atom.PriceType}
 */
proto.job.LadyJobInfo.prototype.getPriceType = function() {
  return /** @type {!proto.atom.PriceType} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.atom.PriceType} value
 * @return {!proto.job.LadyJobInfo} returns this
 */
proto.job.LadyJobInfo.prototype.setPriceType = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional int64 single_price = 6;
 * @return {number}
 */
proto.job.LadyJobInfo.prototype.getSinglePrice = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.job.LadyJobInfo} returns this
 */
proto.job.LadyJobInfo.prototype.setSinglePrice = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int64 need_person = 7;
 * @return {number}
 */
proto.job.LadyJobInfo.prototype.getNeedPerson = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.job.LadyJobInfo} returns this
 */
proto.job.LadyJobInfo.prototype.setNeedPerson = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional google.protobuf.Timestamp deadline = 8;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.job.LadyJobInfo.prototype.getDeadline = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 8));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.job.LadyJobInfo} returns this
*/
proto.job.LadyJobInfo.prototype.setDeadline = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.job.LadyJobInfo} returns this
 */
proto.job.LadyJobInfo.prototype.clearDeadline = function() {
  return this.setDeadline(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.job.LadyJobInfo.prototype.hasDeadline = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional atom.ConditionsType condition_type = 9;
 * @return {!proto.atom.ConditionsType}
 */
proto.job.LadyJobInfo.prototype.getConditionType = function() {
  return /** @type {!proto.atom.ConditionsType} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {!proto.atom.ConditionsType} value
 * @return {!proto.job.LadyJobInfo} returns this
 */
proto.job.LadyJobInfo.prototype.setConditionType = function(value) {
  return jspb.Message.setProto3EnumField(this, 9, value);
};


/**
 * optional bool is_register = 10;
 * @return {boolean}
 */
proto.job.LadyJobInfo.prototype.getIsRegister = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.job.LadyJobInfo} returns this
 */
proto.job.LadyJobInfo.prototype.setIsRegister = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};


/**
 * optional atom.EntityInfo entity_info = 11;
 * @return {?proto.atom.EntityInfo}
 */
proto.job.LadyJobInfo.prototype.getEntityInfo = function() {
  return /** @type{?proto.atom.EntityInfo} */ (
    jspb.Message.getWrapperField(this, jkf$board_board$atom_atom_pb.EntityInfo, 11));
};


/**
 * @param {?proto.atom.EntityInfo|undefined} value
 * @return {!proto.job.LadyJobInfo} returns this
*/
proto.job.LadyJobInfo.prototype.setEntityInfo = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.job.LadyJobInfo} returns this
 */
proto.job.LadyJobInfo.prototype.clearEntityInfo = function() {
  return this.setEntityInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.job.LadyJobInfo.prototype.hasEntityInfo = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional atom.AdsInfo ads_info = 12;
 * @return {?proto.atom.AdsInfo}
 */
proto.job.LadyJobInfo.prototype.getAdsInfo = function() {
  return /** @type{?proto.atom.AdsInfo} */ (
    jspb.Message.getWrapperField(this, jkf$board_board$atom_atom_pb.AdsInfo, 12));
};


/**
 * @param {?proto.atom.AdsInfo|undefined} value
 * @return {!proto.job.LadyJobInfo} returns this
*/
proto.job.LadyJobInfo.prototype.setAdsInfo = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.job.LadyJobInfo} returns this
 */
proto.job.LadyJobInfo.prototype.clearAdsInfo = function() {
  return this.setAdsInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.job.LadyJobInfo.prototype.hasAdsInfo = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional int64 total_price = 13;
 * @return {number}
 */
proto.job.LadyJobInfo.prototype.getTotalPrice = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.job.LadyJobInfo} returns this
 */
proto.job.LadyJobInfo.prototype.setTotalPrice = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.job.AllJobListReq.prototype.toObject = function(opt_includeInstance) {
  return proto.job.AllJobListReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.job.AllJobListReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.job.AllJobListReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    accessToken: jspb.Message.getFieldWithDefault(msg, 1, ""),
    page: jspb.Message.getFieldWithDefault(msg, 2, 0),
    limit: jspb.Message.getFieldWithDefault(msg, 3, 0),
    city: jspb.Message.getFieldWithDefault(msg, 4, ""),
    jobStartAtFrom: (f = msg.getJobStartAtFrom()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    jobStartAtTo: (f = msg.getJobStartAtTo()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    priceType: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.job.AllJobListReq}
 */
proto.job.AllJobListReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.job.AllJobListReq;
  return proto.job.AllJobListReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.job.AllJobListReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.job.AllJobListReq}
 */
proto.job.AllJobListReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccessToken(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPage(value);
      break;
    case 3:
      var value = /** @type {!proto.atom.Limit} */ (reader.readEnum());
      msg.setLimit(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCity(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setJobStartAtFrom(value);
      break;
    case 6:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setJobStartAtTo(value);
      break;
    case 7:
      var value = /** @type {!proto.atom.PriceType} */ (reader.readEnum());
      msg.setPriceType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.job.AllJobListReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.job.AllJobListReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.job.AllJobListReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.job.AllJobListReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccessToken();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getCity();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getJobStartAtFrom();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getJobStartAtTo();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getPriceType();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
};


/**
 * optional string access_token = 1;
 * @return {string}
 */
proto.job.AllJobListReq.prototype.getAccessToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.job.AllJobListReq} returns this
 */
proto.job.AllJobListReq.prototype.setAccessToken = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 page = 2;
 * @return {number}
 */
proto.job.AllJobListReq.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.job.AllJobListReq} returns this
 */
proto.job.AllJobListReq.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional atom.Limit limit = 3;
 * @return {!proto.atom.Limit}
 */
proto.job.AllJobListReq.prototype.getLimit = function() {
  return /** @type {!proto.atom.Limit} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.atom.Limit} value
 * @return {!proto.job.AllJobListReq} returns this
 */
proto.job.AllJobListReq.prototype.setLimit = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional string city = 4;
 * @return {string}
 */
proto.job.AllJobListReq.prototype.getCity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.job.AllJobListReq} returns this
 */
proto.job.AllJobListReq.prototype.setCity = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional google.protobuf.Timestamp job_start_at_from = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.job.AllJobListReq.prototype.getJobStartAtFrom = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.job.AllJobListReq} returns this
*/
proto.job.AllJobListReq.prototype.setJobStartAtFrom = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.job.AllJobListReq} returns this
 */
proto.job.AllJobListReq.prototype.clearJobStartAtFrom = function() {
  return this.setJobStartAtFrom(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.job.AllJobListReq.prototype.hasJobStartAtFrom = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.Timestamp job_start_at_to = 6;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.job.AllJobListReq.prototype.getJobStartAtTo = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 6));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.job.AllJobListReq} returns this
*/
proto.job.AllJobListReq.prototype.setJobStartAtTo = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.job.AllJobListReq} returns this
 */
proto.job.AllJobListReq.prototype.clearJobStartAtTo = function() {
  return this.setJobStartAtTo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.job.AllJobListReq.prototype.hasJobStartAtTo = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional atom.PriceType price_type = 7;
 * @return {!proto.atom.PriceType}
 */
proto.job.AllJobListReq.prototype.getPriceType = function() {
  return /** @type {!proto.atom.PriceType} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.atom.PriceType} value
 * @return {!proto.job.AllJobListReq} returns this
 */
proto.job.AllJobListReq.prototype.setPriceType = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.job.AllJobListRes.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.job.AllJobListRes.prototype.toObject = function(opt_includeInstance) {
  return proto.job.AllJobListRes.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.job.AllJobListRes} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.job.AllJobListRes.toObject = function(includeInstance, msg) {
  var f, obj = {
    infoList: jspb.Message.toObjectList(msg.getInfoList(),
    proto.job.LadyJobInfo.toObject, includeInstance),
    total: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.job.AllJobListRes}
 */
proto.job.AllJobListRes.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.job.AllJobListRes;
  return proto.job.AllJobListRes.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.job.AllJobListRes} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.job.AllJobListRes}
 */
proto.job.AllJobListRes.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.job.LadyJobInfo;
      reader.readMessage(value,proto.job.LadyJobInfo.deserializeBinaryFromReader);
      msg.addInfo(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotal(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.job.AllJobListRes.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.job.AllJobListRes.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.job.AllJobListRes} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.job.AllJobListRes.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInfoList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.job.LadyJobInfo.serializeBinaryToWriter
    );
  }
  f = message.getTotal();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * repeated LadyJobInfo info = 1;
 * @return {!Array<!proto.job.LadyJobInfo>}
 */
proto.job.AllJobListRes.prototype.getInfoList = function() {
  return /** @type{!Array<!proto.job.LadyJobInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.job.LadyJobInfo, 1));
};


/**
 * @param {!Array<!proto.job.LadyJobInfo>} value
 * @return {!proto.job.AllJobListRes} returns this
*/
proto.job.AllJobListRes.prototype.setInfoList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.job.LadyJobInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.job.LadyJobInfo}
 */
proto.job.AllJobListRes.prototype.addInfo = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.job.LadyJobInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.job.AllJobListRes} returns this
 */
proto.job.AllJobListRes.prototype.clearInfoList = function() {
  return this.setInfoList([]);
};


/**
 * optional int64 total = 2;
 * @return {number}
 */
proto.job.AllJobListRes.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.job.AllJobListRes} returns this
 */
proto.job.AllJobListRes.prototype.setTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.job.JobDetailReq.prototype.toObject = function(opt_includeInstance) {
  return proto.job.JobDetailReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.job.JobDetailReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.job.JobDetailReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    accessToken: jspb.Message.getFieldWithDefault(msg, 1, ""),
    trackingNum: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.job.JobDetailReq}
 */
proto.job.JobDetailReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.job.JobDetailReq;
  return proto.job.JobDetailReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.job.JobDetailReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.job.JobDetailReq}
 */
proto.job.JobDetailReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccessToken(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTrackingNum(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.job.JobDetailReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.job.JobDetailReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.job.JobDetailReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.job.JobDetailReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccessToken();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTrackingNum();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string access_token = 1;
 * @return {string}
 */
proto.job.JobDetailReq.prototype.getAccessToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.job.JobDetailReq} returns this
 */
proto.job.JobDetailReq.prototype.setAccessToken = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string tracking_num = 2;
 * @return {string}
 */
proto.job.JobDetailReq.prototype.getTrackingNum = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.job.JobDetailReq} returns this
 */
proto.job.JobDetailReq.prototype.setTrackingNum = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.job.JobDetailRes.repeatedFields_ = [10];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.job.JobDetailRes.prototype.toObject = function(opt_includeInstance) {
  return proto.job.JobDetailRes.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.job.JobDetailRes} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.job.JobDetailRes.toObject = function(includeInstance, msg) {
  var f, obj = {
    jobId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    trackingNum: jspb.Message.getFieldWithDefault(msg, 3, ""),
    jobType: jspb.Message.getFieldWithDefault(msg, 4, 0),
    priceType: jspb.Message.getFieldWithDefault(msg, 5, 0),
    activityId: jspb.Message.getFieldWithDefault(msg, 6, 0),
    singlePrice: jspb.Message.getFieldWithDefault(msg, 7, 0),
    needPerson: jspb.Message.getFieldWithDefault(msg, 8, 0),
    deadline: (f = msg.getDeadline()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    conditionList: jspb.Message.toObjectList(msg.getConditionList(),
    jkf$board_board$atom_atom_pb.Conditions.toObject, includeInstance),
    memo: jspb.Message.getFieldWithDefault(msg, 11, ""),
    entityInfo: (f = msg.getEntityInfo()) && jkf$board_board$atom_atom_pb.EntityInfo.toObject(includeInstance, f),
    adsInfo: (f = msg.getAdsInfo()) && jkf$board_board$atom_atom_pb.AdsInfo.toObject(includeInstance, f),
    isRegister: jspb.Message.getBooleanFieldWithDefault(msg, 14, false),
    totalPrice: jspb.Message.getFieldWithDefault(msg, 15, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.job.JobDetailRes}
 */
proto.job.JobDetailRes.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.job.JobDetailRes;
  return proto.job.JobDetailRes.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.job.JobDetailRes} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.job.JobDetailRes}
 */
proto.job.JobDetailRes.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setJobId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTrackingNum(value);
      break;
    case 4:
      var value = /** @type {!proto.atom.JobType} */ (reader.readEnum());
      msg.setJobType(value);
      break;
    case 5:
      var value = /** @type {!proto.atom.PriceType} */ (reader.readEnum());
      msg.setPriceType(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setActivityId(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSinglePrice(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setNeedPerson(value);
      break;
    case 9:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDeadline(value);
      break;
    case 10:
      var value = new jkf$board_board$atom_atom_pb.Conditions;
      reader.readMessage(value,jkf$board_board$atom_atom_pb.Conditions.deserializeBinaryFromReader);
      msg.addCondition(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setMemo(value);
      break;
    case 12:
      var value = new jkf$board_board$atom_atom_pb.EntityInfo;
      reader.readMessage(value,jkf$board_board$atom_atom_pb.EntityInfo.deserializeBinaryFromReader);
      msg.setEntityInfo(value);
      break;
    case 13:
      var value = new jkf$board_board$atom_atom_pb.AdsInfo;
      reader.readMessage(value,jkf$board_board$atom_atom_pb.AdsInfo.deserializeBinaryFromReader);
      msg.setAdsInfo(value);
      break;
    case 14:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsRegister(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotalPrice(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.job.JobDetailRes.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.job.JobDetailRes.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.job.JobDetailRes} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.job.JobDetailRes.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getJobId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTrackingNum();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getJobType();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getPriceType();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getActivityId();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getSinglePrice();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getNeedPerson();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getDeadline();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getConditionList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      10,
      f,
      jkf$board_board$atom_atom_pb.Conditions.serializeBinaryToWriter
    );
  }
  f = message.getMemo();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getEntityInfo();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      jkf$board_board$atom_atom_pb.EntityInfo.serializeBinaryToWriter
    );
  }
  f = message.getAdsInfo();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      jkf$board_board$atom_atom_pb.AdsInfo.serializeBinaryToWriter
    );
  }
  f = message.getIsRegister();
  if (f) {
    writer.writeBool(
      14,
      f
    );
  }
  f = message.getTotalPrice();
  if (f !== 0) {
    writer.writeInt64(
      15,
      f
    );
  }
};


/**
 * optional int64 job_id = 1;
 * @return {number}
 */
proto.job.JobDetailRes.prototype.getJobId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.job.JobDetailRes} returns this
 */
proto.job.JobDetailRes.prototype.setJobId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.job.JobDetailRes.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.job.JobDetailRes} returns this
 */
proto.job.JobDetailRes.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string tracking_num = 3;
 * @return {string}
 */
proto.job.JobDetailRes.prototype.getTrackingNum = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.job.JobDetailRes} returns this
 */
proto.job.JobDetailRes.prototype.setTrackingNum = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional atom.JobType job_type = 4;
 * @return {!proto.atom.JobType}
 */
proto.job.JobDetailRes.prototype.getJobType = function() {
  return /** @type {!proto.atom.JobType} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.atom.JobType} value
 * @return {!proto.job.JobDetailRes} returns this
 */
proto.job.JobDetailRes.prototype.setJobType = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional atom.PriceType price_type = 5;
 * @return {!proto.atom.PriceType}
 */
proto.job.JobDetailRes.prototype.getPriceType = function() {
  return /** @type {!proto.atom.PriceType} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.atom.PriceType} value
 * @return {!proto.job.JobDetailRes} returns this
 */
proto.job.JobDetailRes.prototype.setPriceType = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional int64 activity_id = 6;
 * @return {number}
 */
proto.job.JobDetailRes.prototype.getActivityId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.job.JobDetailRes} returns this
 */
proto.job.JobDetailRes.prototype.setActivityId = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int64 single_price = 7;
 * @return {number}
 */
proto.job.JobDetailRes.prototype.getSinglePrice = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.job.JobDetailRes} returns this
 */
proto.job.JobDetailRes.prototype.setSinglePrice = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int64 need_person = 8;
 * @return {number}
 */
proto.job.JobDetailRes.prototype.getNeedPerson = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.job.JobDetailRes} returns this
 */
proto.job.JobDetailRes.prototype.setNeedPerson = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional google.protobuf.Timestamp deadline = 9;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.job.JobDetailRes.prototype.getDeadline = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 9));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.job.JobDetailRes} returns this
*/
proto.job.JobDetailRes.prototype.setDeadline = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.job.JobDetailRes} returns this
 */
proto.job.JobDetailRes.prototype.clearDeadline = function() {
  return this.setDeadline(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.job.JobDetailRes.prototype.hasDeadline = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * repeated atom.Conditions condition = 10;
 * @return {!Array<!proto.atom.Conditions>}
 */
proto.job.JobDetailRes.prototype.getConditionList = function() {
  return /** @type{!Array<!proto.atom.Conditions>} */ (
    jspb.Message.getRepeatedWrapperField(this, jkf$board_board$atom_atom_pb.Conditions, 10));
};


/**
 * @param {!Array<!proto.atom.Conditions>} value
 * @return {!proto.job.JobDetailRes} returns this
*/
proto.job.JobDetailRes.prototype.setConditionList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 10, value);
};


/**
 * @param {!proto.atom.Conditions=} opt_value
 * @param {number=} opt_index
 * @return {!proto.atom.Conditions}
 */
proto.job.JobDetailRes.prototype.addCondition = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 10, opt_value, proto.atom.Conditions, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.job.JobDetailRes} returns this
 */
proto.job.JobDetailRes.prototype.clearConditionList = function() {
  return this.setConditionList([]);
};


/**
 * optional string memo = 11;
 * @return {string}
 */
proto.job.JobDetailRes.prototype.getMemo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.job.JobDetailRes} returns this
 */
proto.job.JobDetailRes.prototype.setMemo = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional atom.EntityInfo entity_info = 12;
 * @return {?proto.atom.EntityInfo}
 */
proto.job.JobDetailRes.prototype.getEntityInfo = function() {
  return /** @type{?proto.atom.EntityInfo} */ (
    jspb.Message.getWrapperField(this, jkf$board_board$atom_atom_pb.EntityInfo, 12));
};


/**
 * @param {?proto.atom.EntityInfo|undefined} value
 * @return {!proto.job.JobDetailRes} returns this
*/
proto.job.JobDetailRes.prototype.setEntityInfo = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.job.JobDetailRes} returns this
 */
proto.job.JobDetailRes.prototype.clearEntityInfo = function() {
  return this.setEntityInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.job.JobDetailRes.prototype.hasEntityInfo = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional atom.AdsInfo ads_info = 13;
 * @return {?proto.atom.AdsInfo}
 */
proto.job.JobDetailRes.prototype.getAdsInfo = function() {
  return /** @type{?proto.atom.AdsInfo} */ (
    jspb.Message.getWrapperField(this, jkf$board_board$atom_atom_pb.AdsInfo, 13));
};


/**
 * @param {?proto.atom.AdsInfo|undefined} value
 * @return {!proto.job.JobDetailRes} returns this
*/
proto.job.JobDetailRes.prototype.setAdsInfo = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.job.JobDetailRes} returns this
 */
proto.job.JobDetailRes.prototype.clearAdsInfo = function() {
  return this.setAdsInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.job.JobDetailRes.prototype.hasAdsInfo = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional bool is_register = 14;
 * @return {boolean}
 */
proto.job.JobDetailRes.prototype.getIsRegister = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 14, false));
};


/**
 * @param {boolean} value
 * @return {!proto.job.JobDetailRes} returns this
 */
proto.job.JobDetailRes.prototype.setIsRegister = function(value) {
  return jspb.Message.setProto3BooleanField(this, 14, value);
};


/**
 * optional int64 total_price = 15;
 * @return {number}
 */
proto.job.JobDetailRes.prototype.getTotalPrice = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {number} value
 * @return {!proto.job.JobDetailRes} returns this
 */
proto.job.JobDetailRes.prototype.setTotalPrice = function(value) {
  return jspb.Message.setProto3IntField(this, 15, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.job.PersonalJobListReq.prototype.toObject = function(opt_includeInstance) {
  return proto.job.PersonalJobListReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.job.PersonalJobListReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.job.PersonalJobListReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    accessToken: jspb.Message.getFieldWithDefault(msg, 1, ""),
    page: jspb.Message.getFieldWithDefault(msg, 2, 0),
    limit: jspb.Message.getFieldWithDefault(msg, 3, 0),
    personJobType: jspb.Message.getFieldWithDefault(msg, 4, 0),
    startAt: (f = msg.getStartAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    endAt: (f = msg.getEndAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.job.PersonalJobListReq}
 */
proto.job.PersonalJobListReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.job.PersonalJobListReq;
  return proto.job.PersonalJobListReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.job.PersonalJobListReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.job.PersonalJobListReq}
 */
proto.job.PersonalJobListReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccessToken(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPage(value);
      break;
    case 3:
      var value = /** @type {!proto.atom.Limit} */ (reader.readEnum());
      msg.setLimit(value);
      break;
    case 4:
      var value = /** @type {!proto.atom.PersonalJobType} */ (reader.readEnum());
      msg.setPersonJobType(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setStartAt(value);
      break;
    case 6:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setEndAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.job.PersonalJobListReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.job.PersonalJobListReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.job.PersonalJobListReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.job.PersonalJobListReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccessToken();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getPersonJobType();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getStartAt();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getEndAt();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string access_token = 1;
 * @return {string}
 */
proto.job.PersonalJobListReq.prototype.getAccessToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.job.PersonalJobListReq} returns this
 */
proto.job.PersonalJobListReq.prototype.setAccessToken = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 page = 2;
 * @return {number}
 */
proto.job.PersonalJobListReq.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.job.PersonalJobListReq} returns this
 */
proto.job.PersonalJobListReq.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional atom.Limit limit = 3;
 * @return {!proto.atom.Limit}
 */
proto.job.PersonalJobListReq.prototype.getLimit = function() {
  return /** @type {!proto.atom.Limit} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.atom.Limit} value
 * @return {!proto.job.PersonalJobListReq} returns this
 */
proto.job.PersonalJobListReq.prototype.setLimit = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional atom.PersonalJobType person_job_type = 4;
 * @return {!proto.atom.PersonalJobType}
 */
proto.job.PersonalJobListReq.prototype.getPersonJobType = function() {
  return /** @type {!proto.atom.PersonalJobType} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.atom.PersonalJobType} value
 * @return {!proto.job.PersonalJobListReq} returns this
 */
proto.job.PersonalJobListReq.prototype.setPersonJobType = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional google.protobuf.Timestamp start_at = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.job.PersonalJobListReq.prototype.getStartAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.job.PersonalJobListReq} returns this
*/
proto.job.PersonalJobListReq.prototype.setStartAt = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.job.PersonalJobListReq} returns this
 */
proto.job.PersonalJobListReq.prototype.clearStartAt = function() {
  return this.setStartAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.job.PersonalJobListReq.prototype.hasStartAt = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.Timestamp end_at = 6;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.job.PersonalJobListReq.prototype.getEndAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 6));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.job.PersonalJobListReq} returns this
*/
proto.job.PersonalJobListReq.prototype.setEndAt = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.job.PersonalJobListReq} returns this
 */
proto.job.PersonalJobListReq.prototype.clearEndAt = function() {
  return this.setEndAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.job.PersonalJobListReq.prototype.hasEndAt = function() {
  return jspb.Message.getField(this, 6) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.job.PersonalJobListRes.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.job.PersonalJobListRes.prototype.toObject = function(opt_includeInstance) {
  return proto.job.PersonalJobListRes.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.job.PersonalJobListRes} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.job.PersonalJobListRes.toObject = function(includeInstance, msg) {
  var f, obj = {
    infoList: jspb.Message.toObjectList(msg.getInfoList(),
    proto.job.LadyJobInfo.toObject, includeInstance),
    total: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.job.PersonalJobListRes}
 */
proto.job.PersonalJobListRes.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.job.PersonalJobListRes;
  return proto.job.PersonalJobListRes.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.job.PersonalJobListRes} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.job.PersonalJobListRes}
 */
proto.job.PersonalJobListRes.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.job.LadyJobInfo;
      reader.readMessage(value,proto.job.LadyJobInfo.deserializeBinaryFromReader);
      msg.addInfo(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotal(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.job.PersonalJobListRes.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.job.PersonalJobListRes.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.job.PersonalJobListRes} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.job.PersonalJobListRes.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInfoList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.job.LadyJobInfo.serializeBinaryToWriter
    );
  }
  f = message.getTotal();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * repeated LadyJobInfo info = 1;
 * @return {!Array<!proto.job.LadyJobInfo>}
 */
proto.job.PersonalJobListRes.prototype.getInfoList = function() {
  return /** @type{!Array<!proto.job.LadyJobInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.job.LadyJobInfo, 1));
};


/**
 * @param {!Array<!proto.job.LadyJobInfo>} value
 * @return {!proto.job.PersonalJobListRes} returns this
*/
proto.job.PersonalJobListRes.prototype.setInfoList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.job.LadyJobInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.job.LadyJobInfo}
 */
proto.job.PersonalJobListRes.prototype.addInfo = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.job.LadyJobInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.job.PersonalJobListRes} returns this
 */
proto.job.PersonalJobListRes.prototype.clearInfoList = function() {
  return this.setInfoList([]);
};


/**
 * optional int64 total = 2;
 * @return {number}
 */
proto.job.PersonalJobListRes.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.job.PersonalJobListRes} returns this
 */
proto.job.PersonalJobListRes.prototype.setTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.job.PersonalJobDetailReq.prototype.toObject = function(opt_includeInstance) {
  return proto.job.PersonalJobDetailReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.job.PersonalJobDetailReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.job.PersonalJobDetailReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    accessToken: jspb.Message.getFieldWithDefault(msg, 1, ""),
    trackingNum: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.job.PersonalJobDetailReq}
 */
proto.job.PersonalJobDetailReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.job.PersonalJobDetailReq;
  return proto.job.PersonalJobDetailReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.job.PersonalJobDetailReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.job.PersonalJobDetailReq}
 */
proto.job.PersonalJobDetailReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccessToken(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTrackingNum(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.job.PersonalJobDetailReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.job.PersonalJobDetailReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.job.PersonalJobDetailReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.job.PersonalJobDetailReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccessToken();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTrackingNum();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string access_token = 1;
 * @return {string}
 */
proto.job.PersonalJobDetailReq.prototype.getAccessToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.job.PersonalJobDetailReq} returns this
 */
proto.job.PersonalJobDetailReq.prototype.setAccessToken = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string tracking_num = 2;
 * @return {string}
 */
proto.job.PersonalJobDetailReq.prototype.getTrackingNum = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.job.PersonalJobDetailReq} returns this
 */
proto.job.PersonalJobDetailReq.prototype.setTrackingNum = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.job.PersonalJobDetailRes.repeatedFields_ = [8];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.job.PersonalJobDetailRes.prototype.toObject = function(opt_includeInstance) {
  return proto.job.PersonalJobDetailRes.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.job.PersonalJobDetailRes} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.job.PersonalJobDetailRes.toObject = function(includeInstance, msg) {
  var f, obj = {
    jobId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    trackingNum: jspb.Message.getFieldWithDefault(msg, 3, ""),
    jobType: jspb.Message.getFieldWithDefault(msg, 4, 0),
    priceType: jspb.Message.getFieldWithDefault(msg, 5, 0),
    singlePrice: jspb.Message.getFieldWithDefault(msg, 6, 0),
    totalPrice: jspb.Message.getFieldWithDefault(msg, 7, 0),
    conditionList: jspb.Message.toObjectList(msg.getConditionList(),
    jkf$board_board$atom_atom_pb.Conditions.toObject, includeInstance),
    memo: jspb.Message.getFieldWithDefault(msg, 9, ""),
    deadline: (f = msg.getDeadline()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    personJobType: jspb.Message.getFieldWithDefault(msg, 11, 0),
    entityInfo: (f = msg.getEntityInfo()) && jkf$board_board$atom_atom_pb.EntityInfo.toObject(includeInstance, f),
    adsInfo: (f = msg.getAdsInfo()) && jkf$board_board$atom_atom_pb.AdsInfo.toObject(includeInstance, f),
    needPerson: jspb.Message.getFieldWithDefault(msg, 14, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.job.PersonalJobDetailRes}
 */
proto.job.PersonalJobDetailRes.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.job.PersonalJobDetailRes;
  return proto.job.PersonalJobDetailRes.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.job.PersonalJobDetailRes} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.job.PersonalJobDetailRes}
 */
proto.job.PersonalJobDetailRes.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setJobId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTrackingNum(value);
      break;
    case 4:
      var value = /** @type {!proto.atom.JobType} */ (reader.readEnum());
      msg.setJobType(value);
      break;
    case 5:
      var value = /** @type {!proto.atom.PriceType} */ (reader.readEnum());
      msg.setPriceType(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSinglePrice(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotalPrice(value);
      break;
    case 8:
      var value = new jkf$board_board$atom_atom_pb.Conditions;
      reader.readMessage(value,jkf$board_board$atom_atom_pb.Conditions.deserializeBinaryFromReader);
      msg.addCondition(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setMemo(value);
      break;
    case 10:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDeadline(value);
      break;
    case 11:
      var value = /** @type {!proto.atom.PersonalJobType} */ (reader.readEnum());
      msg.setPersonJobType(value);
      break;
    case 12:
      var value = new jkf$board_board$atom_atom_pb.EntityInfo;
      reader.readMessage(value,jkf$board_board$atom_atom_pb.EntityInfo.deserializeBinaryFromReader);
      msg.setEntityInfo(value);
      break;
    case 13:
      var value = new jkf$board_board$atom_atom_pb.AdsInfo;
      reader.readMessage(value,jkf$board_board$atom_atom_pb.AdsInfo.deserializeBinaryFromReader);
      msg.setAdsInfo(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setNeedPerson(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.job.PersonalJobDetailRes.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.job.PersonalJobDetailRes.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.job.PersonalJobDetailRes} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.job.PersonalJobDetailRes.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getJobId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTrackingNum();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getJobType();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getPriceType();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getSinglePrice();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getTotalPrice();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getConditionList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      8,
      f,
      jkf$board_board$atom_atom_pb.Conditions.serializeBinaryToWriter
    );
  }
  f = message.getMemo();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getDeadline();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getPersonJobType();
  if (f !== 0.0) {
    writer.writeEnum(
      11,
      f
    );
  }
  f = message.getEntityInfo();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      jkf$board_board$atom_atom_pb.EntityInfo.serializeBinaryToWriter
    );
  }
  f = message.getAdsInfo();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      jkf$board_board$atom_atom_pb.AdsInfo.serializeBinaryToWriter
    );
  }
  f = message.getNeedPerson();
  if (f !== 0) {
    writer.writeInt64(
      14,
      f
    );
  }
};


/**
 * optional int64 job_id = 1;
 * @return {number}
 */
proto.job.PersonalJobDetailRes.prototype.getJobId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.job.PersonalJobDetailRes} returns this
 */
proto.job.PersonalJobDetailRes.prototype.setJobId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.job.PersonalJobDetailRes.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.job.PersonalJobDetailRes} returns this
 */
proto.job.PersonalJobDetailRes.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string tracking_num = 3;
 * @return {string}
 */
proto.job.PersonalJobDetailRes.prototype.getTrackingNum = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.job.PersonalJobDetailRes} returns this
 */
proto.job.PersonalJobDetailRes.prototype.setTrackingNum = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional atom.JobType job_type = 4;
 * @return {!proto.atom.JobType}
 */
proto.job.PersonalJobDetailRes.prototype.getJobType = function() {
  return /** @type {!proto.atom.JobType} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.atom.JobType} value
 * @return {!proto.job.PersonalJobDetailRes} returns this
 */
proto.job.PersonalJobDetailRes.prototype.setJobType = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional atom.PriceType price_type = 5;
 * @return {!proto.atom.PriceType}
 */
proto.job.PersonalJobDetailRes.prototype.getPriceType = function() {
  return /** @type {!proto.atom.PriceType} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.atom.PriceType} value
 * @return {!proto.job.PersonalJobDetailRes} returns this
 */
proto.job.PersonalJobDetailRes.prototype.setPriceType = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional int64 single_price = 6;
 * @return {number}
 */
proto.job.PersonalJobDetailRes.prototype.getSinglePrice = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.job.PersonalJobDetailRes} returns this
 */
proto.job.PersonalJobDetailRes.prototype.setSinglePrice = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int64 total_price = 7;
 * @return {number}
 */
proto.job.PersonalJobDetailRes.prototype.getTotalPrice = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.job.PersonalJobDetailRes} returns this
 */
proto.job.PersonalJobDetailRes.prototype.setTotalPrice = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * repeated atom.Conditions condition = 8;
 * @return {!Array<!proto.atom.Conditions>}
 */
proto.job.PersonalJobDetailRes.prototype.getConditionList = function() {
  return /** @type{!Array<!proto.atom.Conditions>} */ (
    jspb.Message.getRepeatedWrapperField(this, jkf$board_board$atom_atom_pb.Conditions, 8));
};


/**
 * @param {!Array<!proto.atom.Conditions>} value
 * @return {!proto.job.PersonalJobDetailRes} returns this
*/
proto.job.PersonalJobDetailRes.prototype.setConditionList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 8, value);
};


/**
 * @param {!proto.atom.Conditions=} opt_value
 * @param {number=} opt_index
 * @return {!proto.atom.Conditions}
 */
proto.job.PersonalJobDetailRes.prototype.addCondition = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.atom.Conditions, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.job.PersonalJobDetailRes} returns this
 */
proto.job.PersonalJobDetailRes.prototype.clearConditionList = function() {
  return this.setConditionList([]);
};


/**
 * optional string memo = 9;
 * @return {string}
 */
proto.job.PersonalJobDetailRes.prototype.getMemo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.job.PersonalJobDetailRes} returns this
 */
proto.job.PersonalJobDetailRes.prototype.setMemo = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional google.protobuf.Timestamp deadline = 10;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.job.PersonalJobDetailRes.prototype.getDeadline = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 10));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.job.PersonalJobDetailRes} returns this
*/
proto.job.PersonalJobDetailRes.prototype.setDeadline = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.job.PersonalJobDetailRes} returns this
 */
proto.job.PersonalJobDetailRes.prototype.clearDeadline = function() {
  return this.setDeadline(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.job.PersonalJobDetailRes.prototype.hasDeadline = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional atom.PersonalJobType person_job_type = 11;
 * @return {!proto.atom.PersonalJobType}
 */
proto.job.PersonalJobDetailRes.prototype.getPersonJobType = function() {
  return /** @type {!proto.atom.PersonalJobType} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {!proto.atom.PersonalJobType} value
 * @return {!proto.job.PersonalJobDetailRes} returns this
 */
proto.job.PersonalJobDetailRes.prototype.setPersonJobType = function(value) {
  return jspb.Message.setProto3EnumField(this, 11, value);
};


/**
 * optional atom.EntityInfo entity_info = 12;
 * @return {?proto.atom.EntityInfo}
 */
proto.job.PersonalJobDetailRes.prototype.getEntityInfo = function() {
  return /** @type{?proto.atom.EntityInfo} */ (
    jspb.Message.getWrapperField(this, jkf$board_board$atom_atom_pb.EntityInfo, 12));
};


/**
 * @param {?proto.atom.EntityInfo|undefined} value
 * @return {!proto.job.PersonalJobDetailRes} returns this
*/
proto.job.PersonalJobDetailRes.prototype.setEntityInfo = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.job.PersonalJobDetailRes} returns this
 */
proto.job.PersonalJobDetailRes.prototype.clearEntityInfo = function() {
  return this.setEntityInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.job.PersonalJobDetailRes.prototype.hasEntityInfo = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional atom.AdsInfo ads_info = 13;
 * @return {?proto.atom.AdsInfo}
 */
proto.job.PersonalJobDetailRes.prototype.getAdsInfo = function() {
  return /** @type{?proto.atom.AdsInfo} */ (
    jspb.Message.getWrapperField(this, jkf$board_board$atom_atom_pb.AdsInfo, 13));
};


/**
 * @param {?proto.atom.AdsInfo|undefined} value
 * @return {!proto.job.PersonalJobDetailRes} returns this
*/
proto.job.PersonalJobDetailRes.prototype.setAdsInfo = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.job.PersonalJobDetailRes} returns this
 */
proto.job.PersonalJobDetailRes.prototype.clearAdsInfo = function() {
  return this.setAdsInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.job.PersonalJobDetailRes.prototype.hasAdsInfo = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional int64 need_person = 14;
 * @return {number}
 */
proto.job.PersonalJobDetailRes.prototype.getNeedPerson = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.job.PersonalJobDetailRes} returns this
 */
proto.job.PersonalJobDetailRes.prototype.setNeedPerson = function(value) {
  return jspb.Message.setProto3IntField(this, 14, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.job.PersonalJobRewardReq.prototype.toObject = function(opt_includeInstance) {
  return proto.job.PersonalJobRewardReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.job.PersonalJobRewardReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.job.PersonalJobRewardReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    accessToken: jspb.Message.getFieldWithDefault(msg, 1, ""),
    startAt: (f = msg.getStartAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    endAt: (f = msg.getEndAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.job.PersonalJobRewardReq}
 */
proto.job.PersonalJobRewardReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.job.PersonalJobRewardReq;
  return proto.job.PersonalJobRewardReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.job.PersonalJobRewardReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.job.PersonalJobRewardReq}
 */
proto.job.PersonalJobRewardReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccessToken(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setStartAt(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setEndAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.job.PersonalJobRewardReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.job.PersonalJobRewardReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.job.PersonalJobRewardReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.job.PersonalJobRewardReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccessToken();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getStartAt();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getEndAt();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string access_token = 1;
 * @return {string}
 */
proto.job.PersonalJobRewardReq.prototype.getAccessToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.job.PersonalJobRewardReq} returns this
 */
proto.job.PersonalJobRewardReq.prototype.setAccessToken = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.Timestamp start_at = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.job.PersonalJobRewardReq.prototype.getStartAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.job.PersonalJobRewardReq} returns this
*/
proto.job.PersonalJobRewardReq.prototype.setStartAt = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.job.PersonalJobRewardReq} returns this
 */
proto.job.PersonalJobRewardReq.prototype.clearStartAt = function() {
  return this.setStartAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.job.PersonalJobRewardReq.prototype.hasStartAt = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.Timestamp end_at = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.job.PersonalJobRewardReq.prototype.getEndAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.job.PersonalJobRewardReq} returns this
*/
proto.job.PersonalJobRewardReq.prototype.setEndAt = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.job.PersonalJobRewardReq} returns this
 */
proto.job.PersonalJobRewardReq.prototype.clearEndAt = function() {
  return this.setEndAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.job.PersonalJobRewardReq.prototype.hasEndAt = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.job.PersonalJobRewardRes.prototype.toObject = function(opt_includeInstance) {
  return proto.job.PersonalJobRewardRes.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.job.PersonalJobRewardRes} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.job.PersonalJobRewardRes.toObject = function(includeInstance, msg) {
  var f, obj = {
    totalAmount: jspb.Message.getFieldWithDefault(msg, 1, 0),
    entityJobAmount: jspb.Message.getFieldWithDefault(msg, 2, 0),
    adJobAmount: jspb.Message.getFieldWithDefault(msg, 3, 0),
    startAt: (f = msg.getStartAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    endAt: (f = msg.getEndAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    reward: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.job.PersonalJobRewardRes}
 */
proto.job.PersonalJobRewardRes.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.job.PersonalJobRewardRes;
  return proto.job.PersonalJobRewardRes.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.job.PersonalJobRewardRes} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.job.PersonalJobRewardRes}
 */
proto.job.PersonalJobRewardRes.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotalAmount(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setEntityJobAmount(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAdJobAmount(value);
      break;
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setStartAt(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setEndAt(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setReward(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.job.PersonalJobRewardRes.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.job.PersonalJobRewardRes.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.job.PersonalJobRewardRes} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.job.PersonalJobRewardRes.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTotalAmount();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getEntityJobAmount();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getAdJobAmount();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getStartAt();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getEndAt();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getReward();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
};


/**
 * optional int64 total_amount = 1;
 * @return {number}
 */
proto.job.PersonalJobRewardRes.prototype.getTotalAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.job.PersonalJobRewardRes} returns this
 */
proto.job.PersonalJobRewardRes.prototype.setTotalAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 entity_job_amount = 2;
 * @return {number}
 */
proto.job.PersonalJobRewardRes.prototype.getEntityJobAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.job.PersonalJobRewardRes} returns this
 */
proto.job.PersonalJobRewardRes.prototype.setEntityJobAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 ad_job_amount = 3;
 * @return {number}
 */
proto.job.PersonalJobRewardRes.prototype.getAdJobAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.job.PersonalJobRewardRes} returns this
 */
proto.job.PersonalJobRewardRes.prototype.setAdJobAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional google.protobuf.Timestamp start_at = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.job.PersonalJobRewardRes.prototype.getStartAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.job.PersonalJobRewardRes} returns this
*/
proto.job.PersonalJobRewardRes.prototype.setStartAt = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.job.PersonalJobRewardRes} returns this
 */
proto.job.PersonalJobRewardRes.prototype.clearStartAt = function() {
  return this.setStartAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.job.PersonalJobRewardRes.prototype.hasStartAt = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.Timestamp end_at = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.job.PersonalJobRewardRes.prototype.getEndAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.job.PersonalJobRewardRes} returns this
*/
proto.job.PersonalJobRewardRes.prototype.setEndAt = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.job.PersonalJobRewardRes} returns this
 */
proto.job.PersonalJobRewardRes.prototype.clearEndAt = function() {
  return this.setEndAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.job.PersonalJobRewardRes.prototype.hasEndAt = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional int64 reward = 6;
 * @return {number}
 */
proto.job.PersonalJobRewardRes.prototype.getReward = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.job.PersonalJobRewardRes} returns this
 */
proto.job.PersonalJobRewardRes.prototype.setReward = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


goog.object.extend(exports, proto.job);
